import React, { useContext, memo } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import { ScrollLink } from '@prisjakt/ui-scroll';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { noop } from '@prisjakt/ui-base';
import { getScrollLinkOffset } from '../../../utils';

const LinkToReviews = ({ product, routeSection, children, onClick }) => {
  const { linkTo, t } = useContext(AppContext);
  return routeSection === 'reviews' ? (
    <ScrollLink
      to="Reviews"
      calculateOffset={getScrollLinkOffset}
      onClick={onClick}
    >
      {children}
    </ScrollLink>
  ) : (
    <Link
      to={linkTo('productReviews', product)}
      onClick={onClick}
      aria-label={t('product', 'tabs.reviews')}
    >
      {children}
    </Link>
  );
};

LinkToReviews.defaultProps = {
  children: null,
  routeSection: null,
  product: null,
  onClick: noop,
};

LinkToReviews.propTypes = {
  children: PropTypes.node,
  routeSection: PropTypes.string,
  product: PropTypes.object,
  onClick: PropTypes.func,
};

export default memo(LinkToReviews);
